import Api from '@/services/Api'

export default {
  getUserData () {
    return Api().get('/account/me')
  },
  changePassword (data) {
    return Api().put('/account/resetPassword', data)
  },

  // Admin
  getAll () {
    return Api().get('/account')
  },
  create (data) {
    return Api().post('/account', data)
  },
  edit (data) {
    return Api().put('/account/' + data.id, data)
  },
  delete (data) {
    return Api().delete('/account/' + data.id)
  },
}
